import {combineReducers} from 'redux'
import customer from './customerReducer';

export default combineReducers({
  customer
})